<template>
  <div class="cat-parent-view">
    <LoadingBounce v-if="busy" />
    <template v-else>
      <template v-if="isUserChildrentList">
        <template v-if="isSupportedChildGrade">
          <div class="row parent-header">
            <div class="col-8 title">{{ $t('proficiency.title', { user: selectedChild.name }) }}</div>
            <div class="col-4 action">
              <span @click="viewChildProficiency()">{{ $t('common.more') }}&gt;</span>
            </div>
          </div>
          <CatProficiency />
        </template>

        <div v-else class="proficiency-container">
          <div class="not-support-grade">
            <div class="title px-0">
              {{ $t('proficiency.title', { user: selectedChild.name }) }}
              <img 
                src="/static/images/ic-info-outline-black.svg"
                alt="classting-score"
                v-b-modal.previewProficiencyModal
              />
            </div>
            <div class="sub-title px-0">
              <span>{{ $t('common.not_support_grade') }}</span>
            </div>
          </div>
        </div>
      </template>
        
        <template v-if="!isUserChildrentList">
          <div class="empty-parent">
            <div class="empty-parent-title">
              {{ $t('parent.main.title') }}
            </div>
            <div class="empty-parent-subtitle" v-html="$t('parent.main.subtitle')" />
            <div class="empty-parent-icon-container">
              <img src="/static/images/img-main-sam@2x.png" class="empty-parent-icon" />
            </div>
          </div>
        </template>

    </template>

    <b-modal
      id="previewProficiencyModal"
      class="preview-proficiency-modal"
      ref="modal"
      centered
      hide-header
      hide-footer
    >
      <slot>
        <div class="preview-proficiency">
          <div class="preview-proficiency-header">{{ $t('common.not_support_grade' )}}</div>
          <div class="preview-proficiency-body">
            <img src="/static/images/img_sample_level.png" alt="icon" />
          </div>
          <div class="preview-proficiency-footer">
            <button
              type="button"
              @click="handleCloseClick"
            >
              {{ $t('common.confirmation') }}
            </button>
          </div>
        </div>
      </slot>
    </b-modal>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import CatProficiency from '../components/CatProficiency';
  import CatSubtitle from '../components/CatSubtitle';

  export default {
    name: 'cat-parent-view',

    components: {
      CatProficiency,
      CatSubtitle,
    },

    computed: {
      ...mapGetters({
        userChildrenList: 'userChildrenList',
        selectedChild: 'getSelectedChild',
        selectedChildId: 'getSelectedChildId',
        busy: 'getBusy',
        isSupportedChildGrade: 'isSupportedChildGrade',
      }),

      isUserChildrentList() {
        return this.userChildrenList && this.userChildrenList.length > 0;
      },
    },

    methods: {
      viewChildProficiency() {
        this.$ga.event({
          eventCategory: 'learning',
          eventLabel: 'view_more_subject',
          eventAction: 'click',
        });

        return this.$router.push(`/proficiency?child_id=${this.selectedChildId}`);
      },

      handleCloseClick() {
        this.$refs.modal.hide();
      },

    },

  };
</script>

<style lang="scss" scoped>

  .cat-parent-view{
    max-width: 946px;
    margin: 0 auto;

    .not-support-grade {
      padding: 24px 0px 24px 0px;

      .title {
        float: left;
        font-size: 18px;
      }

      .sub-title {
        float: right;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
      }
    }

    .parent-header {
      padding: 20px 20px 8px 20px;

      .title {
        font-size: 18px;
        padding: 0;
      }

      .action {
        font-size: 12px;
        text-align: right;
        float: right;

        span {
          color: rgba(0, 0, 0, 0.6);
          text-decoration:none;
          cursor: pointer;
        }
      }
    }

    .empty-parent {
      margin: 24px auto 24px;
      padding: 44px;
      width: 100%;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      height: 440px;
      position: relative;

      .empty-parent-title {
        color: #00c896;
        font-size: 24px;
        text-align: center;
      }

      .empty-parent-subtitle {
        color: #000000;
        font-size: 16px;
        text-align: center;
        padding: 44px;
      }

      .empty-parent-icon-container {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;

        .empty-parent-icon {
          margin: 0 auto;
          display: block;
        }
      }
    }

    .empty-parent-text {
      text-align: center;
      color: rgba(0, 0, 0, 0.6);
    }

    .preview-proficiency {
      .preview-proficiency-header {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
        padding: 14px;
      }

      .preview-proficiency-body {
        img {
          width: 100%
        }
      }

      .preview-proficiency-footer {
        text-align: center;
        padding: 14px;

        button {
          border-radius: 4px;
          background-color: #00c896;
          color: #ffffff;
          border: 0;
          padding: 2% 22%;
          cursor: pointer;
        }
      }
    }

  }

</style>


// WEBPACK FOOTER //
// CatParentView.vue?06c84a42